// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IActionButtonV3Schema {
  /** Событие для аналитики **/
  analyticsName?: string;
  /** Диплинк на чат **/
  chatDeeplink?: string;
  /** Позиционирование кнопки; только для кнопки с типом link **/
  gravity?: EGravity;
  /** Ссылка на иконку кнопки **/
  icon?: string;
  /** Позиция иконки **/
  iconPosition?: EIconPosition;
  /** Ссылка по которой надо перейти в случае выбора этого варианта ответа **/
  link?: string;
  /** Номер телефона **/
  phone?: string;
  /** Вариант который надо отправить по socket-у **/
  socketPayload?: string;
  /** Стиль кнопки **/
  style: EStyle;
  /** Текст ссылки или текст варианта ответа **/
  text: string;
  /**
   *
   *     Тип ответа.
   *     Если ссылка deeplink, то обязательно должно быть поле link.
   *     Если вариант ответа который надо вернут по socket, то обязательно должно быть поле socketPayload.
   *
   */
  type: EType;
}

export enum EGravity {
  /** Заполнение **/
  'Fill' = 'fill',
  /** Начало **/
  'Start' = 'start',
}
export enum EIconPosition {
  /** Конец **/
  'End' = 'end',
  /** Начало **/
  'Start' = 'start',
}
export enum EStyle {
  /** Основная кнопка **/
  'ButtonPrimary' = 'buttonPrimary',
  /** Второстепенная кнопка **/
  'ButtonSecondary' = 'buttonSecondary',
  /** Звонок из чата **/
  'CallChat' = 'callChat',
  /** Ссылка **/
  'Link' = 'link',
}
export enum EType {
  /** Звонок **/
  'Call' = 'call',
  /** Звонок из чата **/
  'CallChat' = 'callChat',
  /** Чат **/
  'Chat' = 'chat',
  /** Диплинк **/
  'Deeplink' = 'deeplink',
  /** Сокет **/
  'Socket' = 'socket',
}
